import { Component, Inject, OnInit } from '@angular/core';
import {APP_BASE_HREF} from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  urlPath = window.location.pathname;
  possibleEnds = ["login", "login/", "config", "config/"]
  loadMantenedor = false;
  constructor() {

  }

  ngOnInit(){
    this.loadMantenedor = this.mantenedor();
  }
  //Si el path termina con algún possible end retorna true
  mantenedor():boolean{
    let aRetornar = this.possibleEnds.reduce((previous, current)=>{ return previous || this.urlPath.endsWith(current) }, false);
    return aRetornar;
  }
  loadMantenedorComp(){
    this.loadMantenedor= true;
  }
}
